import classNames from 'classnames'
import { ComponentProps, ReactElement } from 'react'

export function IconCopy(props: ComponentProps<'svg'>): ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={classNames(props.className, 'w-[1em] h-[1em]')}
    >
      <path
        d="M19.4979 6.06066L17.645 4.43934C17.3235 4.15804 16.8874 4 16.4328 4H10.2857C9.33893 4 8.57143 4.67156 8.57143 5.5V7H5.71429C4.7675 7 4 7.67156 4 8.5V18.5C4 19.3284 4.7675 20 5.71429 20H13.7143C14.6611 20 15.4286 19.3284 15.4286 18.5V17H18.2857C19.2325 17 20 16.3284 20 15.5V7.12131C20 6.72349 19.8194 6.34196 19.4979 6.06066ZM13.5 18.5H5.92857C5.87174 18.5 5.81723 18.4802 5.77705 18.4451C5.73686 18.4099 5.71429 18.3622 5.71429 18.3125V8.6875C5.71429 8.63777 5.73686 8.59008 5.77705 8.55492C5.81723 8.51975 5.87174 8.5 5.92857 8.5H8.57143V15.5C8.57143 16.3284 9.33893 17 10.2857 17H13.7143V18.3125C13.7143 18.3622 13.6917 18.4099 13.6515 18.4451C13.6113 18.4802 13.5568 18.5 13.5 18.5ZM18.0714 15.5H10.5C10.4432 15.5 10.3887 15.4802 10.3485 15.4451C10.3083 15.4099 10.2857 15.3622 10.2857 15.3125V5.6875C10.2857 5.63777 10.3083 5.59008 10.3485 5.55492C10.3887 5.51975 10.4432 5.5 10.5 5.5H14.2857V8.25C14.2857 8.66422 14.6695 9 15.1429 9H18.2857V15.3125C18.2857 15.3622 18.2631 15.4099 18.223 15.4451C18.1828 15.4802 18.1283 15.5 18.0714 15.5V15.5ZM18.2857 7.5H16V5.5H16.344C16.4008 5.5 16.4553 5.51975 16.4955 5.55491L18.223 7.06641C18.2429 7.08382 18.2586 7.10449 18.2694 7.12724C18.2802 7.14999 18.2857 7.17438 18.2857 7.199V7.5Z"
        fill="#232323"
      />
    </svg>
  )
}
